/* -----------------------------------------------------------------------------------------------------
  - Created: [31-01-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains dashboard  contents 
  -------------------------------------------------------------------------------------------------------
*/
import React, { createContext, useEffect, useState } from 'react';
import './DashboardStyle.css';
import FinanceDashboard from './FinanceDashboard/FinanceDashboard';
import ManagerDashboard from './ManagerDashboard/ManagerDashboard';
import SupervisorDashboard from './SupervisorDashboard/SupervisorDashboard';
import { getUserData } from '../../utils/localStorage';
import { fetchDashboardDataByRole } from '../../config/Dashboard/dashboardApis';
import AdminDashboard from './AdminDashboard/AdminDashboard';
import { setPageTitle } from '../../utils/setPageTitle';

export const dashboardContext = createContext();

function Dashboard() {

    const userData = getUserData()

    // Initialize with current values
    const currentYear = new Date().getFullYear();
    const [year, setYear] = useState(currentYear);

    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false); // Loader state

    // DASHBOARD ENDPOINTS BASED ON ROLE
    const returnDashboardEndpoint = () => {
        switch (userData?.RoleId) {
            case 6: // Finance
            case 24: // Main Finance
                return { endpoint: 'FinanceDashboard' };
            case 4: //MANAGER
                return { endpoint: 'ManagementDashboard ' };
            case 2: //SUPERVISOR
                return { endpoint: 'SupervisorDashboard' };
            default: //OTHER LOGINS
                return { endpoint: 'AdminDashboard' };
        }
    }
    const { endpoint } = returnDashboardEndpoint();

    // FETCH DASHBOARD DATA BASED ON ROLE
    const fetchDashboard = async () => {
        try {
            setIsLoading(true);
            const params = endpoint === 'AdminDashboard' ? { year: Number(year) } : {};
            const response = await fetchDashboardDataByRole(endpoint, params);
            if (response?.status === 'success') {
                setData(response.data || []);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Dashboard fetch error", error);
            setData([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        setPageTitle(`Dashboard`);
        fetchDashboard();
    }, [userData?.RoleId, year]);

    const renderDashboard = () => {
        switch (userData?.RoleId) {
            case 6: //FINANCE
            case 24: // Main Finance
                return <FinanceDashboard />;
            case 4: //MANAGER
                return <ManagerDashboard />;
            case 2: //SUPERVISOR
                return <SupervisorDashboard />;
            default: //OTHER LOGINS
                return <AdminDashboard />;
        }
    }


    //update the selected   duration
    const handleYearChange = (selectedYear) => {
        setYear(selectedYear);
    };

    return (
        <dashboardContext.Provider value={{ data, isLoading, year, handleYearChange }}>
            {renderDashboard()}
        </dashboardContext.Provider>
    );
}

export default Dashboard;